import React from "react";
import './style.css';
import RaisedButton from "material-ui/RaisedButton";
import { translate } from "admin-on-rest";
import ExportIcon from "./ExportIcon";
import moment from "moment";

const styles = {
  headerDiv: {
    display: 'flex',
    justifyContent: 'space-between',
    boxShadow: 'rgba(0, 0, 0, 0.5) 0px 2px 5px 1px',
    alignItems: 'center',
    marginBottom: '16px'
  },
  headerText: {
    padding: '16px',
    fontWeight: 400,
    fontSize: '24px',
    margin: 0
  },
  filter: {
    display: 'flex'
  },
  datePicker: {
    padding: '0 10px'
  },
  buttonDiv: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    padding: '10px 15px',
    borderRadius: 2,
    fontSize: '16px',
    backgroundColor: 'rgb(109, 199, 195)',
    boxShadow: 'rgba(0, 0, 0, 0.5) 0px 2px 5px 1px',
    color: 'white',
    border: 0
  }
}
class CustomerPhonesAnalyticsDataList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date()
    }
    this.download = this.download.bind(this);
    this.handleErrorResponse = this.handleErrorResponse.bind(this);
  }

  download() {
    const token = localStorage.getItem('token');    

    let anchor = document.createElement("a");
    document.body.appendChild(anchor);

    fetch(`${process.env.REACT_APP_API_URL}/reporting/all_customer_phones`, {
      method: 'GET',
      headers: {
        'Content-type': 'text/plain',
        'Authorization': `Bearer ${token}`,
      }
    })
    .then(response => {
      if(response.status === 400){
        return response.json();
      } else {
        return response.blob();
      }
    })
    .then(data => {
      if(data.errors){
        this.handleErrorResponse(data.errors);
      } else {
        const dateString = moment(this.state.date).format('YYYY-MM-DD');
        const blobby = data;
        const objectUrl = URL.createObjectURL(blobby);
        anchor.href = objectUrl;
        anchor.download = `customer_phones_report-${dateString}.txt`;
        anchor.click();
        URL.revokeObjectURL(objectUrl);
      }
    })
    .catch(error => {
      console.error(error);
    });
  }

  handleErrorResponse(errors){
    const {translate} = this.props;

    if (document.getElementById('errorDiv').innerHTML) {
      return '';
    } else {
      if(errors){
        const div = document.createElement("div");
        const errMsg = (errors && errors.length) ? errors[0].detail : null;
        const errorText = document.createTextNode(errMsg);
        div.appendChild(errorText);
        document.getElementById('errorDiv').appendChild(div);
      } else {
        const div = document.createElement("div");
        const errMsg = translate("resources.reports.chooseBothDates");
        const errorText = document.createTextNode(errMsg);
        div.appendChild(errorText);
        document.getElementById('errorDiv').appendChild(div);
      }      
    }
  }

  render() {
    const {translate} = this.props;
    return (
      <React.Fragment>
        <div style={styles.headerDiv}>
          <div>
            <h1 style={styles.headerText}>{translate("resources.reports.customerPhonesReportsTitle")}</h1>
          </div>
        </div>
        <div id="errorDiv" />
        <div style={styles.buttonDiv}>
          <RaisedButton 
            id="export"
            type="submit"
            label={translate("resources.reports.exportAction")}
            primary
            icon={<ExportIcon />}
            onClick={this.download}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default translate(CustomerPhonesAnalyticsDataList);



// WEBPACK FOOTER //
// ./src/containers/CRM/AnalyticsData/CustomerPhonesAnalyticsList.js